import { Box } from '@mui/material';
import { useEffect } from 'react';

export function StickyBottomContainer({ sx, children, placeholderHeight }) {
  useEffect(() => {
    const setViewportCssVars = () => {
      const vv = window.visualViewport;
      if (!vv) {
        document.documentElement.style.setProperty('--vv-bottom', '0px');
        return;
      }

      // Height of the “obscured” bottom area when mobile browser UI (address/search bar)
      // expands/collapses. We use it to keep the CTA pinned to the visible viewport.
      const bottomInset = Math.max(
        0,
        window.innerHeight - (vv.height + vv.offsetTop)
      );
      document.documentElement.style.setProperty(
        '--vv-bottom',
        `${bottomInset}px`
      );
    };

    setViewportCssVars();
    window.visualViewport?.addEventListener('resize', setViewportCssVars);
    window.visualViewport?.addEventListener('scroll', setViewportCssVars);
    window.addEventListener('resize', setViewportCssVars);
    window.addEventListener('orientationchange', setViewportCssVars);

    return () => {
      window.visualViewport?.removeEventListener('resize', setViewportCssVars);
      window.visualViewport?.removeEventListener('scroll', setViewportCssVars);
      window.removeEventListener('resize', setViewportCssVars);
      window.removeEventListener('orientationchange', setViewportCssVars);
    };
  }, []);

  return (
    <>
      <Box sx={{ height: placeholderHeight }} />
      <Box
        sx={{
          position: 'fixed',
          left: 0,
          bottom: 0,
          pb: 'calc(var(--vv-bottom, 0px) + env(safe-area-inset-bottom, 0px) + 12px)',
          width: '100%',
          zIndex: 1200,
          background: 'linear-gradient(to bottom, transparent 0%, white 16px)',
          pt: 2,
          ...sx,
        }}
      >
        {children}
      </Box>
    </>
  );
}
